import { parseImsDate } from 'js/hooks/useFormatter/helpers';

import { LIMIT_FIELD_EXTRA_DATA, LIMIT_FIELD_NAMES, LIMIT_TYPES, LIMIT_FIELD_PERIODS } from './constants';

const parseDateSafe = d => d ? parseImsDate(d) : null;

const parseDate = date => Number(parseDateSafe(date));

const typeToName = type => LIMIT_FIELD_NAMES[type];

const typeToPeriod = type => LIMIT_FIELD_PERIODS[type];

export const formatData = (data, form) => {
    const { initialValues } = form.getState();

    return Object.fromEntries(
        Object.entries(data)
            .filter(([key, value]) => initialValues[key] !== Number(value))
            .map(([key, value]) => [key, Number(value)])
    );
};

export const parseRawLimits = (rawLimits, config = []) => rawLimits
    .filter(limit => limit.limitType !== LIMIT_TYPES.BAN_ON_BET_AFTER_LOGOUT && config[typeToName(limit.limitType)])
    .map(limit => ({
        ...limit,
        startDate: parseDate(limit.startDate),
        endDate: parseDate(limit.endDate),
        name: typeToName(limit.limitType),
        timePeriod: typeToPeriod(limit.limitType)
    }))
    .reduce((acc, limit) => {
        const { name, pending = false } = limit;
        const key = pending ? 'pendingLimits' : 'limits';

        acc[key] = {
            ...acc[key],
            [name]: limit
        };

        return acc;
    }, { limits: {}, pendingLimits: {} });

export const parseLimits = (limits = {}, config) => Object.entries(LIMIT_FIELD_NAMES)
    .reduce((acc, [limitType, name]) => {
        const limit = limits[name] || { limitType: parseInt(limitType) };

        return {
            ...acc,
            [name]: {
                ...limit,
                ...LIMIT_FIELD_EXTRA_DATA[limitType],
                name,
                allowed: config[name]
            }
        };
    }, {});

export const parsePendingLimits = (limits = {}) => Object.entries(limits)
    .map(([name, limit]) => ({
        ...limit,
        ...LIMIT_FIELD_EXTRA_DATA[limit.limitType],
        date: limit.startDate,
        name
    }));

const convertTime = minutes => ({
    dd: Math.floor(minutes / 24 / 60),
    hh: Math.floor(minutes / 60 % 24),
    mm: minutes % 60
});

export const formatTimeLimit = (minutes, t) => {
    const { dd, hh, mm } = convertTime(minutes);
    const timeOnly = `${hh} ${t('date.hh')} ${mm} ${t('date.min')}`;

    if (dd) {
        return `${dd} ${t('date.dd')} ${timeOnly}`;
    }

    return timeOnly;
};
